import {createBrowserHistory} from 'history'

const browserHistory = createBrowserHistory()

export const navigateTo = (path: string) => browserHistory.push(path)
export const redirectTo = (path: string) => browserHistory.replace(path)

export default browserHistory
